module.exports = __webpack_public_path__ + "img/03-rocket-over-glare.30cbf414.png";